import styled from "styled-components";
import { LIGHT_BLUE } from "../../../config";

export const SeeAllItems = styled.div`
  display: flex;
  align-content: flex-end;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;

  p {
    color: ${LIGHT_BLUE};
    cursor: pointer;
    font-weight: bold;
    line-height: 32px;
    font-size: 14px;
    margin: 0;
  }
`;

export const Content = styled.div`
  font-size: 14px;
  padding-top: 16px;
  .field {
    margin-bottom: 24px;
    &.text-area-field {
      margin-bottom: 0px;
    }
  }
`;

export const List = styled.div`
  box-sizing: border-box;
  padding: 0.5rem;
  max-height: 250px;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: scroll;
  overflow-x: hidden;

  div {
    padding: 20px;
    margin: 10px;
    cursor: pointer;
  }
`;
